module.exports = __webpack_public_path__ + "static/gate4-0e74cb131ca0f3d9ad77782bd5c4e3ed.png";